// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3999":"d32f80e1","7570":"ccdfd3eb"}[chunkId] + ".chunk.css";
};